import { ChangeEvent, ReactElement, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "../../../../components/tabPanel";
import { useSelector } from "react-redux";
import { IState } from "../../../../types";
import VariablesConfig from "./variablesConfig";
import AxisConfig from "./axisConfig";

interface IProps {
  parentSize: {
    width: number;
    height: number;
  };
}

const a11yProps = (index: number): any => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};

const VariablesPage = ({ parentSize }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [tabSelected, setTabSelected] = useState(0);

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  const gridStyle = {
    height: parentSize.height,
  };

  return (
    <div style={gridStyle}>
      <Tabs
        value={tabSelected}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="Variables" {...a11yProps(0)} />
        <Tab label="Axes" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={tabSelected} index={0} >
        <VariablesConfig />
      </TabPanel>
      <TabPanel value={tabSelected} index={1} >
        <AxisConfig  />
      </TabPanel>
    </div>
  );
};

export default VariablesPage;
